/* SRP: Triggers event when dropdown is changed */

import dom from '../../lib/dom.js';
import fn from '../../lib/fn.js';
import preconditions from '../../lib/preconditions.js';

const T = FINN.travel;

const checkPreconditions = preconditions('sortingDropdown', {
    key: 'string',
    root: 'element',
    eventHub: 'object',
    resultViewCriteria: 'object',
    dropdownKeys: 'object',
    urlKey: 'string',
});

const updateResultViewCriteria = (params) => {
    params.resultViewCriteria[params.urlKey] = params.root.value;
    params.eventHub.publish('resultViewCriteria:changed');
};

const publishAddedFilter = (params) => {
    params.eventHub.publish('filters:added', {
        filterId: params.urlKey,
        urlKey: params.urlKey,
        urlValue: params.root.value,
        text: `Sortert på ${params.root.options[params.root.selectedIndex].text.toLowerCase()}`,
        remove: () => {
            params.root.selectedIndex = 0;
            params.eventHub.publish('filters:removed', params.urlKey);
            updateResultViewCriteria(params);
        },
    });
};

const changed = (params) => {
    if (params.root.selectedIndex === 0) {
        params.eventHub.publish('filters:removed', params.urlKey);
    } else {
        publishAddedFilter(params);
    }
    if (params.trackSort) {
        params.trackSort('dropdown', params.root.value);
    }
    updateResultViewCriteria(params);
};

const updateSelected = (params) => {
    if (params.resultViewCriteria[params.urlKey]) {
        fn.forEach(params.root.options, (option, idx) => {
            if (option.value === params.resultViewCriteria[params.urlKey]) {
                params.root.selectedIndex = idx;
            }
        });
    } else if (params.defaultDropdownValue) {
        fn.forEach(params.root.options, (option, idx) => {
            if (option.value === params.defaultDropdownValue) {
                params.root.selectedIndex = idx;
            }
        });
    } else {
        params.root.selectedIndex = 0;
    }
};

const setStateFromUrl = (params) => {
    const query = params.urlQueryParams[params.urlKey];
    if (query && query.length) {
        let x;
        for (x = 0; x < params.root.options.length; x += 1) {
            if (params.root.options[x].value === query[0]) {
                params.root.selectedIndex = x;
                changed(params);

                break;
            }
        }
    } else if (params.defaultDropdownValue) {
        fn.forEach(params.root.options, (option, idx) => {
            if (option.value === params.defaultDropdownValue) {
                params.root.selectedIndex = idx;
                changed(params);
            }
        });
    } else if (params.root.selectedIndex !== 0) {
        params.root.selectedIndex = 0;
        changed(params);
    }
};

const setupDropdown = (params) => {
    checkPreconditions(params);

    const createOption = (key) => {
        const option = document.createElement('option');
        option.setAttribute('data-testid', 'sortingDropdownOption');
        option.value = key;
        option.label = T.lang[key]();
        option.text = T.lang[key]();
        return option;
    };

    const createOptions = () => {
        for (const key of params.dropdownKeys) {
            const option = createOption(key);
            params.root.appendChild(option);
        }
    };

    createOptions();
    dom.on(params.root, 'change', () => {
        changed(params);
    });

    params.eventHub.subscribe('resultViewCriteria:changed', () => {
        updateSelected(params);
    });
};

export default {
    forFlight: (params) => {
        setupDropdown(params);
        updateSelected(params);
    },

    forPale: (params) => {
        setupDropdown(params);
        if (params.urlQueryParams) {
            setStateFromUrl(params);
        }

        params.eventHub.subscribe('urlQueryParams:changed', () => {
            setStateFromUrl(params);
        });
    },
};
